import { Box } from "@mui/material";
import styled from "styled-components";

export const SuggestionWrapper = styled(Box)`
  margin: 0;
  padding: 0;
`;
export const SuggestionList = styled.ul`
  background-color: #fff;
  border-radius: 4px;
  list-style: none;
  position: absolute;
  width: 100%;
  padding: 0;
  margin-top: 10px;
  z-index: 10;
  overflow: auto;
  max-height: 200px;
  font-size: 15px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
`;

export const OptionWrapper = styled.li`
  cursor: pointer;
  display: block;
  padding: 6px 12px;
  color: #404040;
  font-weight: 700;
  width: 100%;
  height: 47px;
  &:hover {
    background-color: rgb(0 0 0/5%);
  }
`;

export const Option = styled.div`
  font-weight: 700;
`;

export const SubOption = styled.div`
  font-size: 10px;
  line-height: 15px;
`;
